export enum Locales {
  NlNL = 'nl-NL',
  EnUS = 'en-US',
  EsES = 'es-ES',
  DeDE = 'de-DE',
  PlPL = 'pl-PL',
  DaDK = 'da-DK',
  SvSE = 'sv-SE',
  NbNO = 'nb-NO',
  ItIT = 'it-IT',
  FrFR = 'fr-FR',
  // Declared before PtBR: a device reporting a bare "pt" resolves to the first match.
  PtPT = 'pt-PT',
  PtBR = 'pt-BR',
}

export const fallbackLocale = Locales.EnUS;
